export { default } from "./TablePagination.mjs";
export { default as tablePaginationClasses } from "./tablePaginationClasses.mjs";
export * from "./tablePaginationClasses.mjs";